// extracted by mini-css-extract-plugin
module.exports = {"Advantage":"Advantage_Advantage__1Lukc","Item":"Advantage_Item__3XoFd","Title":"Advantage_Title__uxaP1","Description":"Advantage_Description__3rhdU","Icon":"Advantage_Icon__YqTDR"};